// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type And from "../contract/And";

export default function and(data: And): And {
    const result: And = {
        __type: "And:#Exchange",
        ...data,
    };
    
    return result;
}
